<ng-template [ngIf]="sortedMessages && sortedMessages.length" [ngIfElse]="emptyList">
  <div *ngFor="let message of sortedMessages" class="pb-2">
    <cbp-log-message [message]="message" [sendToProviderDate]="sendToProviderDate"></cbp-log-message>
  </div>
</ng-template>

<ng-template #emptyList>
  <div>
    {{ "NO_MESSAGES_FROM_CBP" | translate }}
  </div>
</ng-template>
